<template lang="html">
  <header
    :class="[{ 'nav-collapsed': isSidebarCollapsed, 'nav-expanded': isSidebarHovered }]"
    class="header-top"
    header-theme="dark">
    <div class="container-fluid">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <button
            type="button"
            class="btn-icon mobile-nav-toggle d-lg-none">
            <span />
          </button>
        </div>
        <div class="d-flex align-items-center header-buttons">
          <charge-balance />
          <charge-new
            v-if="isAdmin"
            slider-name="chargeAmountSliderMenuHeader"
            class="ml-3" />
        </div>
        <div class="d-flex align-items-center ml-auto logged-user">
          <span>
            <small class="text-info">usuário:</small> <b>{{ this.$store.state.auth.user && this.$store.state.auth.user.name }}</b>
            <small class="text-info">organização:</small> <b>{{ this.$store.state.auth.organization && this.$store.state.auth.organization.name }}</b>
            <small class="text-info">acesso:</small> <b>{{ accessType }}</b>
          </span>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import ChargeBalance from '@/components/Charge/Balance.vue'
import ChargeNew from '@/components/Charge/New.vue'

export default {
  name: 'MenuHeader',
  components: {
    ChargeBalance,
    ChargeNew
  },
  data () {
    return {
      isSidebarHovered: false,
      isSidebarCollapsed: false
    }
  },
  created () {
    this.$root.$on('sidebar-hover', (isHovered) => {
      this.isSidebarHovered = isHovered
    })
    this.$root.$on('sidebar-toggle', (isCollapsed) => {
      this.isSidebarCollapsed = isCollapsed
    })
  },
  computed: {
    accessType () {
      if (this.$store.state.auth.user && this.$store.state.auth.user.role === 'ADMIN') {
        return 'Administrador'
      } else {
        return 'Usuário'
      }
    },
    isAdmin () {
      return this.$store.state.auth.user && this.$store.state.auth.user.role === 'ADMIN'
    }
  }
}
</script>

<style lang="scss" scoped>
.charge-balance {
  color: var(--white);
}
.logged-user {
  color: var(--white);
  font-size: 14px;
  .text-info {
    margin-left: 10px;
  }
}

.header-top {
  transition: padding 0.3s ease;
  &.nav-collapsed.nav-expanded {
    padding-left: clamp(230px, 13vw, 250px);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Container/MenuHeader.vue